export type MarketingEventName =
  | 'landing_cta_click'
  | 'pricing_cta_click'
  | 'feature_cta_click';

export type MarketingPayload = Record<
  string,
  string | number | boolean | null | undefined
>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

export function trackMarketingEvent(
  name: MarketingEventName,
  payload: MarketingPayload = {}
): void {
  if (!isBrowser()) return;

  const event = {
    event: name,
    timestamp: Date.now(),
    path: window.location.pathname,
    referrer: document.referrer || null,
    ...payload,
  };

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(event);
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', name, event);
  }
}
